import React, { FC, ReactElement } from 'react'
import cn from 'classnames';

interface ChevronProps {
  open: boolean
};

const Chevron: FC<ChevronProps> = ({ open }): ReactElement => {
  return (
    <svg
      className={cn('select__panel-svg', { 'select__panel-svg--active': open })}
      width='8'
      height='5'
      viewBox='0 0 8 5'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M7.79565 1.29196L4.6 4.71325C4.41304 4.90889 4.22609 4.99988 4 4.99988C3.76957 4.99533 3.58261 4.90889 3.4 4.71325L0.204348 1.28741C0.0652175 1.14637 4.76837e-07 0.97349 4.76837e-07 0.764209C4.76837e-07 0.345647 0.326087 -0.00012207 0.721739 -0.00012207C0.917391 -0.00012207 1.1087 0.0817704 1.25652 0.245556L3.99565 3.21644L6.74348 0.245556C6.8913 0.0863204 7.07826 -0.00012207 7.27826 -0.00012207C7.67391 -0.00012207 8 0.345647 8 0.764209C8 0.968941 7.93043 1.14183 7.79565 1.29196Z' />
    </svg>
  );
};

export default Chevron;
